import Vue from "vue";
import Router from "vue-router";

// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Views
const Dashboard = () => import("@/views/Dashboard");
const MainPage = () => import("@/views/MainPage");
const BlankPage = () => import("@/views/pages/BlankPage");
const Insight = () => import("@/views/pages/Insight");
const InsightOnline = () => import("@/views/pages/InsightOnline");
const TrustPilotOverview = () => import("@/views/TrustPilotOverview");

const Actions = () => import("@/views/base/Actions");
const Allmessages = () => import("@/views/base/Allmessages");

const Colors = () => import("@/views/theme/Colors");
const Typography = () => import("@/views/theme/Typography");

const Charts = () => import("@/views/charts/Charts");
const Widgets = () => import("@/views/widgets/Widgets");

// Views - Components
const Cards = () => import("@/views/base/Cards");
const Forms = () => import("@/views/base/Forms");
const Switches = () => import("@/views/base/Switches");
const Tables = () => import("@/views/base/Tables");
const Tabs = () => import("@/views/base/Tabs");
const Breadcrumbs = () => import("@/views/base/Breadcrumbs");
const Carousels = () => import("@/views/base/Carousels");
const Collapses = () => import("@/views/base/Collapses");
const Jumbotrons = () => import("@/views/base/Jumbotrons");
const ListGroups = () => import("@/views/base/ListGroups");
const Navs = () => import("@/views/base/Navs");
const Navbars = () => import("@/views/base/Navbars");
const Paginations = () => import("@/views/base/Paginations");
const Popovers = () => import("@/views/base/Popovers");
const ProgressBars = () => import("@/views/base/ProgressBars");
const Tooltips = () => import("@/views/base/Tooltips");

// Views - Buttons
const StandardButtons = () => import("@/views/buttons/StandardButtons");
const ButtonGroups = () => import("@/views/buttons/ButtonGroups");
const Dropdowns = () => import("@/views/buttons/Dropdowns");
const BrandButtons = () => import("@/views/buttons/BrandButtons");

// Views - Icons
const CoreUIIcons = () => import("@/views/icons/CoreUIIcons");
const Brands = () => import("@/views/icons/Brands");
const Flags = () => import("@/views/icons/Flags");

// Views - Notifications
const Alerts = () => import("@/views/notifications/Alerts");
const Badges = () => import("@/views/notifications/Badges");
const Modals = () => import("@/views/notifications/Modals");

// Views - Pages
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");

const Register = () => import("@/views/pages/Register");

// Users
const Users = () => import("@/views/users/Users");
const User = () => import("@/views/users/User");

// Views - Campaigns
const Reviews = () => import("@/views/base/Reviews");
const Campaigns = () => import("@/views/base/Campaigns");
const StepByStep = () => import("@/views/base/StepByStep");
const Adsets = () => import("@/views/base/Adsets");
const Ads = () => import("@/views/base/Ads");
const partners = () => import("@/views/base/Partners");
const strategy = () => import("@/views/base/StrategyAction");
const line = () => import("@/views/base/line");
const FacebookPages = () => import("@/views/base/facebookPage");
const Stereotypes = () => import("@/views/base/Stereotype");
const AdsAccounts = () => import("@/views/base/AdsAccounts");
const Pixels = () => import("@/views/base/Pixel");
const Promotions = () => import("@/views/base/Promotion");
const Business = () => import("@/views/base/Business");
const Propuesta = () => import("@/views/base/Propuesta");
const CodPostal = () => import("@/views/base/CodPostal");
const Ideologia = () => import("@/views/base/Ideologia");
const Provincia = () => import("@/views/base/Provincia");
const Audiencia = () => import("@/views/base/Audiencia");
const WebSites = () => import("@/views/base/WebSites");
const Quiz = () => import("@/views/base/Quiz");
const QuizForm = () => import("@/views/base/QuizesForm");
// const CreateQuiz = () => import("@/views/notifications/ModalCreateQuiz")
const CreateQuiz = () => import("@/views/base/CreateQuiz");
const EditQuiz = () => import("@/views/base/EditQuiz");
const DuplicateQuiz = () => import("@/views/base/DuplicateQuiz");
const Analyze_Survey = () => import("@/views/base/Analyze/Analyze_Surveys");
const Answer = () => import("@/views/base/Analyze/Answer");

const ReviewDetail = () => import("@/views/base/ReviewDetail");
const insight_analyze = () => import("@/views/base/Analyze/Insights_Analyze");
const welcome = () => import("@/views/base/Welcome");
const Listing = () => import("@/views/base/Listing");
const LocationDetail = () => import("@/views/base/LocationDetail");
const PartnerDetail = () => import("@/views/base/PartnerDetail");
const ActionsModerate = () => import("@/views/base/ActionsModerate");
const Error = () => import("@/views/pages/error")
const Ok = () => import("@/views/pages/ok")
const Front = () => import("@/views/pages/front")


// Views - Pages
// const Page404 = () => import("@/views/pages/Page404");
// const Page500 = () => import("@/views/pages/Page500");
// const Login = () => import("@/views/pages/Login");

import store from "../store";
import VueRouter from "vue-router";

Vue.use(Router);
Vue.use(VueRouter);

let router = new Router({
  mode: "hash", // https://router.vuejs.org/api/#mode
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
});

function configRoutes() {
  return [
    {
      path: "/",
      redirect: "/login",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "login",
          name: "Login",
          component: Login,
          meta: {
            isLoged: true,
          },
        },
        {
          path: "404",
          name: "Page404",
          component: Page404,
        },
        {
          path: "500",
          name: "Page500",
          component: Page500,
        },
        {
          path: "register",
          name: "Register",
          component: Register,
        },
      ],
    },
    {
      path: "/dashboard",
      redirect: "/home",
      name: "Home",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "",
          name: "Dashboard",
          component: Dashboard,
        },
      ],
    },
    {
      path: "/trustpilotoverview",
      redirect: "/home",
      name: "Home",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "",
          name: "TrustPilotOverview",
          component: TrustPilotOverview,
        },
      ],
    },
    {
      path: "/blank",
      redirect: "/home",
      name: "Home",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/blank",
          name: "Blank",
          component: BlankPage,
        },
      ],
    },
    {
      path: "/home",
      redirect: "/home",
      name: "Home",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/home",
          name: "MainPage",
          component: welcome,
        },
      ],
    },
    {
      path: "/home",
      redirect: "/home",
      name: "Home",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/welcome",
          name: "MainPage",
          component: welcome,
        },
      ],
    },
    {
      path: "/home",
      redirect: "/home",
      name: "Home",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/settings",
          name: "MainPage",
          component: MainPage,
        },
      ],
    },
    {
      path: "/campaigns",
      redirect: "/home",
      name: "Home",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/campaigns",
          name: "Campañas",
          component: StepByStep,
        },
      ],
    },
    // {
    //   path: "/campaigns",
    //   redirect: "/dashboard",
    //   name: "Home",
    //   component: TheContainer,
    //   meta: {
    //     requiresAuth: true
    //   },
    //   children: [
    //     {
    //       path: "",
    //       name: "Campañas",
    //       component: Campaigns
    //     }
    //   ]
    // },
    // {
    //   path: "/reviews",
    //   redirect: "/home",
    //   name: "Home",
    //   component: TheContainer,
    //   meta: {
    //     requiresAuth: true
    //   },
    //   children: [
    //     {
    //       path: "/reviews",
    //       name: "Reviews",
    //       component: Reviews
    //     }
    //   ]
    // },
    {
      path: "/Moderate-old",
      redirect: "/home",
      name: "Home",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/Moderate-old",
          name: "Moderateold",
          component: Actions,
        },
      ],
    },

    {
      path: "/Moderate",
      redirect: "/home",
      name: "Home",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/Moderate",
          name: "Moderate",
          component: ActionsModerate,
        },
      ],
    },

    {
      path: "/Allmessages",
      redirect: "/home",
      name: "Home",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/Allmessages",
          name: "Allmessages",
          component: Allmessages,
        },
      ],
    },

    {
      path: "/segmentationstrategies",
      redirect: "/home",
      name: "Home",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/segmentationstrategies",
          name: "Segmentation Strategies",
          component: Stereotypes,
        },
      ],
    },
    // {
    //   path: "/campaigns",
    //   redirect: "/home",
    //   name: "Home",
    //   component: TheContainer,
    //   meta: {
    //     requiresAuth: true
    //   },
    //   children: [
    //     {
    //       path: "/campaigns",
    //       name: "Campaigns",
    //       component: StepByStep
    //     }
    //   ]
    // },
    {
      path: "/insight",
      redirect: "/home",
      name: "Home",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/insight",
          name: "Insight",
          component: Insight,
        },
      ],
    },
    {
      path: "/insightonline",
      redirect: "/home",
      name: "Home",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/insightonline",
          name: "InsightOnline",
          component: InsightOnline,
        },
      ],
    },
    {
      path: "/analyze",
      redirect: "/home",
      name: "Home",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/analyze",
          name: "Analyze",
          component: Analyze_Survey,
        },
        {
          path: "/answer/:itemID",
          name: "Analyze",
          component: Answer,
          props: true,
        },
        {
          path: "/insight_analyze",
          name: "Insight",
          component: insight_analyze,
        },
      ],
    },
    {
      path: "/review",
      redirect: "/home",
      name: "Home",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/review/:itemID",
          name: "Review",
          component: Reviews,
          props: true,
        },
      ],
    },
    {
      path: "/adsets",
      redirect: "/dashboard",
      name: "Adsets",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "",
          name: "Conjuto de anuncios",
          component: Adsets,
        },
      ],
    },
    {
      path: "/ads",
      redirect: "/dashboard",
      name: "Ads",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "",
          name: "Anuncios",
          component: Ads,
        },
      ],
    },
    // {
    //   path: "/step-by-step",
    //   redirect: "/dashboard",
    //   name: "Step by Step",
    //   component: TheContainer,
    //   meta: {
    //     requiresAuth: true
    //   },
    //   children: [
    //     {
    //       path: "",
    //       name: "Step By Step",
    //       component: StepByStep
    //     }
    //   ]
    // },
    {
      path: "/partners",
      redirect: "/dashboard",
      name: "partners",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "",
          name: "Clientes",
          component: partners,
        },
        {
          path: "/acciones-estrategicas",
          name: "Acciones Estratégicas",
          component: strategy,
        },
        {
          path: "/promociones",
          name: "Promociones",
          component: Promotions,
        },
        {
          path: "/lineas-contenido",
          name: "Líneas de Contenido",
          component: line,
        },
        {
          path: "/propuestas",
          name: "Propuestas",
          component: Propuesta,
        },
        {
          path: "/ideologias",
          name: "Ideologías",
          component: Ideologia,
        },
        {
          path: "/provincias",
          name: "Provincias",
          component: Provincia,
        },
        {
          path: "/cod-postales",
          name: "Cód. Postales",
          component: CodPostal,
        },
        {
          path: "/estereotipos",
          name: "Segmentation Strategies",
          component: Stereotypes,
        },
        {
          path: "/audiencias",
          name: "Audiencias",
          component: Audiencia,
        },
      ],
    },
    {
      path: "/lines",
      redirect: "/dashboard",
      name: "Líne content",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "",
          name: "Line Content Table",
          component: line,
        },
      ],
    },
    {
      path: "/pages",
      redirect: "/dashboard",
      name: "Facebook Page",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "",
          name: "Facebook Page Table",
          component: FacebookPages,
        },
      ],
    },
    {
      path: "/stereotypes",
      redirect: "/dashboard",
      name: "Stereotypes",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "",
          name: "Stereotypes Table",
          component: Stereotypes,
        },
      ],
    },
    {
      path: "/ads-accounts",
      redirect: "/dashboard",
      name: "Ads Accounts",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "",
          name: "Ads Accounts Table",
          component: AdsAccounts,
        },
      ],
    },
    {
      path: "/pixels",
      redirect: "/dashboard",
      name: "Pixels",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "",
          name: "Pixels Table",
          component: Pixels,
        },
      ],
    },
    {
      path: "/promotions",
      redirect: "/dashboard",
      name: "Promotions",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "",
          name: "Promotions Table",
          component: Promotions,
        },
      ],
    },
    {
      path: "/business",
      redirect: "/dashboard",
      name: "Business",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "",
          name: "Business Table",
          component: Business,
        },
      ],
    },
    {
      path: "/web-sites",
      redirect: "/dashboard",
      name: "Web sites",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "",
          name: "Web sites",
          component: WebSites,
        },
      ],
    },
    {
      path: "/Surveys",
      redirect: "/Surveys",
      name: "Listen",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/Surveys",
          name: "Surveys",
          component: Quiz,
        },
      ],
    },
    {
      path: "/listing",
      redirect: "/home",
      name: "Home",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/listing",
          name: "Listings",
          component: Listing,
        },
        {
          path: "/location/:itemID",
          name: "Location",
          component: LocationDetail,
          props: true,
        },
      ],
    },
    {
      path: "/settings",
      redirect: "/home",
      name: "Home",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/settings",
          name: "Settings",
          component: Listing,
        },
        {
          path: "/partner/:itemID",
          name: "Partner",
          component: PartnerDetail,
          props: true,
        },
      ],
    },
    {
      path: "/createquiz",
      redirect: "home",
      name: "Home",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/createquiz",
          name: "CreateQuiz",
          component: CreateQuiz,
        },
        {
          path: "/createquiz/:itemID",
          name: "CreateQuiz",
          component: CreateQuiz,
          props: true,
        },
      ],
    },
    {
      path: "/editquiz",
      redirect: "home",
      name: "Home",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/editquiz",
          name: "EditQuiz",
          component: EditQuiz,
          props: true,
        },
      ],
    },
    {
      path: "/duplicatequiz",
      redirect: "home",
      name: "Home",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/duplicatequiz",
          name: "DuplicateQuiz",
          component: DuplicateQuiz,
          props: true,
        },
      ],
    },
    {
      path: "/quiz-form",
      redirect: "/dashboard",
      name: "Quizes",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "",
          name: "Quizes",
          component: QuizForm,
        },
      ],
    },
    {
      path: "/provedor-internet",
      redirect: "/dashboard",
      name: "Provedor de internet",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "",
          name: "Provedor de internet",
          component: Business,
        },
      ],
    },
    {
      path: "/isp",
      redirect: "/dashboard",
      name: "ISP",
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "",
          name: "ISP",
          component: Business,
        },
      ],
    },
    {
      path: '/err',
      component: Error,
      name: "Error"

    },
    {
      path: '/ok',
      component: Ok,
      name: "Ok"
    },
    {
      path: '/front',
      component: Front,
      name: "Front"
    }
  ];
}

router.beforeEach((to, from, next) => {
  // console.log("store.getters.isLoggedIn", to,"::::::::", to.matched.some(record => record.meta.isLoged) ,"::::::::::::", to.matched.some(record => record.meta.requiresAuth));
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    router.push('/login');
  } else if (to.matched.some((record) => record.meta.isLoged)) {
    //console.log("record.meta.isLoged, store.getters.isLoggedIn", record.meta.isLoged ,store.getters.isLoggedIn);
    if (store.getters.isLoggedIn) {
      router.push('/home');
      return;
    }
    next();
  } else {
    next();
  }
});
export default router;
